import React from "react";
import { IoAddOutline, IoReaderOutline } from "react-icons/io5";
import { PagePath } from "../../../navigation/routes";
import { useAppSelector } from "../../../store/hooks";
import { canCreateTicketGrid } from "../../../utils/userPermissions";
import { HeaderItem } from "../HeaderItem";
import { HeaderSubRowStyled } from "../styled/Header.styled";

export function TicketGridsSubNav() {
  const userType = useAppSelector((s) => s.user.info?.type);
  const showCreate = canCreateTicketGrid(userType);

  return (
    <HeaderSubRowStyled>
      <HeaderItem
        path={PagePath.ticketGrids.templates}
        subItem={true}
        notReady={false}
      >
        <IoReaderOutline />
        Сетки
      </HeaderItem>

      {showCreate ? (
        <HeaderItem
          path={PagePath.ticketGrids.createTemplate}
          subItem={true}
          notReady={false}
        >
          <IoAddOutline />
          Добавить новую
        </HeaderItem>
      ) : null}
    </HeaderSubRowStyled>
  );
}
